<template>
  <div>     
    <div class="col-12 px-1 pt-0">
      <!-- Description -->
      <div class="row px-2 py-0 m-0">
        <div class="col-12 px-0">
          <hr class="text-secondary">
          <h5 class="font-weight-bold">Description</h5>
          <div class="card text-left mt-3 py-3 px-3 bg-light rounded-lg">
            {{targetDetail.description_sell}}
          </div>
        </div>
      </div>
     
      <div class="mt-4 px-0">
        <div class="row my-3 mx-0 px-0">
          <div class="col-4 p-0 mx-0 my-3"  
            v-for="(item, index) in targetDetail.questions.data.find( e => e.question === 5).answers" :key="index">
              <div class="px-2  h-100">                        
                <p class="font-weight-bold my-2">
                  Problem solved {{ index + 1}}
                </p>
                <div class="card col-12 mx-0  my-0 py-3 px-3 rounded-lg bg-light  h-100">
                {{item.text}}
              </div>
             </div>
            
          </div>
        </div>

        <div class="row my-3 mx-0 px-0">
          <div class="col-4 p-0 my-3"  
            v-for="(item, index) in targetDetail.questions.data.find( e => e.question === 6).answers" :key="index">
              <div class="px-2 h-100">                          
                <p class="font-weight-bold my-2">
                  Social Proof {{ index + 1}}
                </p>
                <div class="card col-12 mx-1 my-0 py-3 rounded-lg bg-light h-100">
                  {{item.text}}
                </div>
              </div>            
          </div>
        </div>    
      </div>
    </div>
  </div>
</template>

<script>
import { proporsalService, adminService } from "@/_services";
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { formattersMixin } from "@/_mixins/";

export default {
  name: "TargetDetail",
  components: {
    LoadingSpinner,    
  },
  props: {
    targetId: {
      type: String,
      required: true,
    },
    // client: {
    //   type: Object,
    //   required: true,
    //   default: () => {},
    // },
    specialOrderDiscountCountDown: {
      type: String,
      required: false,
      default: "",
    },
    toShowOpportunity: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  
  data() {
    return {
      loading: false,
      loadingSequence: false,
      verificationOrder: [],
      targetDetailData: false,
      lang:'eng',
      apolloResult: false,
      step2sum: 2322,
      targetkey: 232232,
      salesSelected: [],
      salesRep: [],
      employess:[],
      categoryJobs:[],
      loadingSales: true,
      targetDetail: {},
      tabSelected: 1,
      editing: [],  
    };
  },
  created() {
    this.getOrderDetail();
  },
  mixins: [formattersMixin],
  computed: {
    ...mapState({
      availableTokens: (state) => state.optionsList.all["available_tokens"],
    }),
  },

  methods: {
    getOrderDetail() {
      this.loading = true;
      proporsalService
        .getOrderDetail(this.targetId)
        .then((res) => {

          this.targetDetail = JSON.parse(JSON.stringify(res));
          
          let lang_id = res.language_id;
          if(lang_id == 1){
            this.lang = 'fr'
          }else{
            if(lang_id == 2){
              this.lang = 'eng'
            }else{
              this.lang = 'spa'
            }
          }

          //this.getApollo(data);
          this.loadingSales = false;
          this.loading = false;

          this.$emit('loadingCompleted')

        })
        .catch((err) => console.log(err));
    },
    
  },
};
</script>

<style scoped>
</style>
